import * as React from "react";
import { forwardRef } from "react";
const SvgTiltLimitArrow = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 13, height: 19, viewBox: "0 0 13 19", fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9.57656 10.3171L10.7344 9.5L9.57656 8.68294L2.82656 3.9198L1.25 2.80731V4.73686L1.25 14.2631V16.1927L2.82656 15.0802L9.57656 10.3171Z", fill: "#BEE3F8", stroke: "black", strokeWidth: 2 }));
const ForwardRef = forwardRef(SvgTiltLimitArrow);
export { ForwardRef as ReactComponent };
